import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Row, Col, Button, Card } from '@components/bootstrap';
import RoleModal from './RoleModal';
import './RoleManagement.scss';
const RoleManagement = () => {
    const [roles, setRoles] = useState([
        {
            id: '1',
            name: 'Administrador',
            permissions: ['users.read', 'users.write', 'roles.read', 'roles.write', 'system.admin'],
            createdAt: '2024-01-15T10:30:00Z',
        },
        {
            id: '2',
            name: 'Moderador',
            permissions: ['users.read', 'content.moderate', 'reports.read'],
            createdAt: '2024-01-20T14:45:00Z',
        },
        {
            id: '3',
            name: 'Usuário',
            permissions: ['profile.read', 'profile.write'],
            createdAt: '2024-02-01T09:15:00Z',
        },
    ]);
    const [showModal, setShowModal] = useState(false);
    const [modalMode, setModalMode] = useState('add');
    const [selectedRole, setSelectedRole] = useState(null);
    const [modalData, setModalData] = useState({
        name: '',
        permissions: []
    });
    const permissions = [
        { id: 'users.read', name: 'Visualizar Usuários', description: 'Pode visualizar lista de usuários' },
        { id: 'users.write', name: 'Gerenciar Usuários', description: 'Pode criar, editar e excluir usuários' },
        { id: 'roles.read', name: 'Visualizar Perfis', description: 'Pode visualizar perfis do sistema' },
        { id: 'roles.write', name: 'Gerenciar Perfis', description: 'Pode criar, editar e excluir perfis' },
        { id: 'content.moderate', name: 'Moderar Conteúdo', description: 'Pode moderar conteúdo do sistema' },
        { id: 'reports.read', name: 'Visualizar Relatórios', description: 'Pode visualizar relatórios' },
        { id: 'profile.read', name: 'Visualizar Perfil', description: 'Pode visualizar próprio perfil' },
        { id: 'profile.write', name: 'Editar Perfil', description: 'Pode editar próprio perfil' },
        { id: 'system.admin', name: 'Administração do Sistema', description: 'Acesso total ao sistema' },
    ];
    const handleAddRole = () => {
        setModalMode('add');
        setModalData({ name: '', permissions: [] });
        setSelectedRole(null);
        setShowModal(true);
    };
    const handleEditRole = (role) => {
        setModalMode('edit');
        setModalData({
            id: role.id,
            name: role.name,
            permissions: role.permissions
        });
        setSelectedRole(role);
        setShowModal(true);
    };
    const handleDeleteRole = (role) => {
        setModalMode('delete');
        setSelectedRole(role);
        setShowModal(true);
    };
    const handleSaveRole = (data) => {
        if (modalMode === 'add') {
            const newRole = {
                id: (roles.length + 1).toString(),
                name: data.name,
                permissions: data.permissions,
                createdAt: new Date().toISOString(),
            };
            setRoles([...roles, newRole]);
        }
        else if (modalMode === 'edit' && selectedRole) {
            setRoles(roles.map(role => role.id === selectedRole.id
                ? { ...role, name: data.name, permissions: data.permissions }
                : role));
        }
        setShowModal(false);
    };
    const handleConfirmDelete = () => {
        if (selectedRole) {
            setRoles(roles.filter(role => role.id !== selectedRole.id));
        }
        setShowModal(false);
    };
    const getPermissionNames = (permissionIds) => {
        return permissionIds
            .map(id => permissions.find(p => p.id === id)?.name)
            .filter(Boolean)
            .join(', ');
    };
    return (_jsxs("div", { className: "role-management", children: [_jsx(Row, { children: _jsx(Col, { xs: 12, children: _jsxs(Card, { children: [_jsxs("div", { className: "card-header d-flex justify-content-between align-items-center", children: [_jsx("h5", { className: "mb-0", children: "\uD83D\uDD10 Gest\u00E3o de Perfis" }), _jsx(Button, { variant: "primary", size: "sm", onClick: handleAddRole, children: "\u2795 Novo Perfil" })] }), _jsx("div", { className: "card-body", children: _jsx("div", { className: "table-responsive", children: _jsxs("table", { className: "table table-hover", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Nome do Perfil" }), _jsx("th", { children: "Permiss\u00F5es" }), _jsx("th", { children: "Data de Cria\u00E7\u00E3o" }), _jsx("th", { children: "A\u00E7\u00F5es" })] }) }), _jsx("tbody", { children: roles.map((role) => (_jsxs("tr", { children: [_jsx("td", { children: _jsx("strong", { children: role.name }) }), _jsx("td", { children: _jsx("div", { className: "permissions-list", children: role.permissions.map((permissionId, index) => {
                                                                    const permission = permissions.find(p => p.id === permissionId);
                                                                    return permission ? (_jsx("span", { className: "badge bg-secondary me-1 mb-1", children: permission.name }, index)) : null;
                                                                }) }) }), _jsx("td", { children: new Date(role.createdAt).toLocaleDateString('pt-BR') }), _jsx("td", { children: _jsxs("div", { className: "btn-group", role: "group", children: [_jsx(Button, { variant: "primary", size: "sm", onClick: () => handleEditRole(role), children: "\u270F\uFE0F Editar" }), _jsx(Button, { variant: "danger", size: "sm", onClick: () => handleDeleteRole(role), children: "\uD83D\uDDD1\uFE0F Excluir" })] }) })] }, role.id))) })] }) }) })] }) }) }), _jsx(RoleModal, { show: showModal, mode: modalMode, data: modalData, permissions: permissions, role: selectedRole, onClose: () => setShowModal(false), onSave: handleSaveRole, onDelete: handleConfirmDelete })] }));
};
export default RoleManagement;
